import { getCompMeta } from '../index';
import { cloneDeep, merge } from "lodash-es";
export const replace = ({
  ctx,
  sourceLayout,
  targetLayout,
  targetCompId
}) => {
  const sourceMeta = getCompMeta(ctx, sourceLayout.type);
  const targetMeta = getCompMeta(ctx, targetCompId);
  const newLayout = targetLayout || cloneDeep(sourceLayout);
  newLayout.type = targetCompId;
  // 先全都塞到新对象里 然后按照schema合法裁掉多余的
  newLayout.props = merge({}, sourceLayout.props, newLayout.props);
  // props裁剪
  Object.entries(newLayout.props).forEach(([key]) => {
    const sourceField = sourceMeta.propsSchema.fields.find(field => field.id === key);
    const targetField = targetMeta.propsSchema.fields.find(field => field.id === key);
    // 如果类型不一致 或不存在 就裁掉
    if (!targetField || (sourceField === null || sourceField === void 0 ? void 0 : sourceField.type) !== (targetField === null || targetField === void 0 ? void 0 : targetField.type)) {
      delete newLayout.props[key];
    }
  });
  newLayout.events = merge({}, sourceLayout.events, newLayout.events);
  const getEventId = ev => ev.asProp ? `:${ev.asProp}` : ev.id;
  // events裁剪
  Object.entries(newLayout.events).forEach(([key]) => {
    var _targetMeta$events;
    const targetEventSchema = (_targetMeta$events = targetMeta.events) === null || _targetMeta$events === void 0 ? void 0 : _targetMeta$events.find(event => getEventId(event) === key);
    if (!targetEventSchema) {
      delete newLayout.events[key];
    }
  });
  return {
    layout: newLayout
  };
};
//# sourceMappingURL=plainReplace.js.map
